import React from "react";

interface HighlightIconProps {
  className?: string;
  onClick?: () => void;
}

export const HighlightIcon = ({ className, onClick }: HighlightIconProps) => (
  <svg
    width="30"
    height="34"
    viewBox="0 0 30 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <circle cx="15" cy="16.0871" r="15" fill="#FFECD6" />
    <path
      d="M23.75 19.5715C23.75 20.0403 23.5859 20.4387 23.2578 20.7668L20.3047 23.72C19.9766 24.0481 19.5781 24.2121 19.1094 24.2121H9.6875C9.21875 24.2121 8.82031 24.0481 8.49219 23.72C8.16406 23.3918 8 22.9934 8 22.5246V10.1496C8 9.68089 8.16406 9.28246 8.49219 8.95433C8.82031 8.62621 9.21875 8.46214 9.6875 8.46214H22.0625C22.5312 8.46214 22.9297 8.62621 23.2578 8.95433C23.5859 9.28246 23.75 9.68089 23.75 10.1496V19.5715ZM19.4961 22.9114L22.4492 19.9582C22.5195 19.8879 22.5781 19.8059 22.625 19.7121H19.25V23.052C19.3438 23.0285 19.4258 22.9817 19.4961 22.9114ZM22.625 10.1496C22.625 9.98558 22.5664 9.85667 22.4492 9.76292C22.3555 9.64574 22.2266 9.58714 22.0625 9.58714H9.6875C9.52344 9.58714 9.38281 9.64574 9.26562 9.76292C9.17188 9.85667 9.125 9.98558 9.125 10.1496V22.5246C9.125 22.6887 9.17188 22.8293 9.26562 22.9465C9.38281 23.0403 9.52344 23.0871 9.6875 23.0871H18.125V19.4309C18.125 19.1965 18.207 18.9973 18.3711 18.8332C18.5352 18.6692 18.7344 18.5871 18.9688 18.5871H22.625V10.1496Z"
      fill="#FFA740"
    />
  </svg>
);

HighlightIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
